import { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { Button, Input, Tabs } from '@/components/ui';
import { RegistrationsLogPanel } from './components/RegistrationsLogPanel';
import { EventsLogPanel } from './components/EventsLogPanel';

export function DuMonitorDashboardPage() {
  const [search, setSearch] = useState('');
  const [appliedSearch, setAppliedSearch] = useState('');

  const tabs = useMemo(
    () => [
      {
        label: 'Registration Log',
        content: <RegistrationsLogPanel searchText={appliedSearch} />,
      },
      {
        label: 'Events Log',
        content: <EventsLogPanel searchText={appliedSearch} />,
      },
    ],
    [appliedSearch],
  );

  function applySearch() {
    setAppliedSearch(search.trim());
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 border-b border-cool-gray-2 pb-5 md:flex-row md:items-end md:justify-between">
        <h1 className="text-2xl font-bold leading-9 text-black">DU-Monitor Dashboard</h1>
        <form
          className="flex w-full flex-col gap-2 sm:max-w-[350px] sm:flex-row sm:items-end"
          onSubmit={(event) => {
            event.preventDefault();
            applySearch();
          }}
        >
          <Input
            id="dashboard-search"            
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search By Name"
            autoComplete="off"
          />
          <Button type="submit" size="md" className="h-10 gap-2 sm:w-auto">
            <Search aria-hidden="true" size={16} />
            Apply
          </Button>
        </form>
      </div>

      <Tabs tabs={tabs} aria-label="DU-Monitor dashboard sections" />
    </div>
  );
}